import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {
    sites: [],
    facilities: [],
    companies: [],
    showAllSites: false,
    showAllGroups: false,
    showAllFacilities: false,
    openDialog: false,
    downloadingReportResults: false,
    report: null
  }
};

const slice = createSlice({
  name: 'adminReports',
  initialState,
  reducers: {
    setSites: (state, action) => {
      state.data.sites = action.payload || [];
    },
    setCompaniesAndFacilities: (state, action) => {
      state.data.companies = action.payload.companies || [];
      state.data.facilities = action.payload.facilities || [];
    },
    setShowAllSites: (state, action) => {
      state.data.showAllSites = action.payload;
    },
    setShowAllGroups: (state, action) => {
      state.data.showAllGroups = action.payload;
    },
    setShowAllFacilities: (state, action) => {
      state.data.showAllFacilities = action.payload;
    },
    setOpenDialog: (state, action) => {
      state.data.openDialog = action.payload;
    },
    setDownloadingReportResults: (state, action) => {
      state.data.downloadingReportResults = action.payload;
    },
    setReport: (state, action) => {
      state.data.report = action.payload || null;
    },
    resetAdminReportState: (state) => {
      state.data = {
        ...initialState.data,
        report: null
      };
    }
  }
});

export const {
  setSites,
  setCompaniesAndFacilities,
  setShowAllSites,
  setShowAllGroups,
  setShowAllFacilities,
  setOpenDialog,
  setDownloadingReportResults,
  setReport,
  resetAdminReportState
} = slice.actions;

export default slice.reducer;
